import { useEffect } from "react";
import { SectionSkeleton } from "@/components/profile-cards";
import { useCompanyDetails } from "@/hooks/useCompanyDetails";
import { useFetchLoanOfficerProfile } from "@/pages/Onboarding/LoanOfficer/hooks/useFetchLoanOfficerProfile";
import { useAppStore } from "@/store/app/slice";
import { UserRole } from "@/types/users";
import { CompanyDetails } from "../components/CompanyDetails";

const LoanOfficerDetailsSections = () => {
  const { profile } = useFetchLoanOfficerProfile();
  const {
    data: companyDetails,
    loading: companyLoading,
    getCompanyDetails,
  } = useCompanyDetails();

  useEffect(() => {
    if (!profile?.lenderId) return;

    getCompanyDetails({
      id: profile.lenderId,
      companyType: "lender",
    });
  }, [getCompanyDetails, profile]);

  if (!profile || companyLoading) {
    return <SectionSkeleton />;
  }

  return <CompanyDetails company={companyDetails} companyType="lender" />;
};

const LoanOfficerDetails = () => {
  const user = useAppStore((s) => s.user);

  if (user?.role !== UserRole.LoanOfficer) return null;

  return <LoanOfficerDetailsSections />;
};

export default LoanOfficerDetails;
